import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import { createListenCollectionEpic, createListenDocEpic } from './epics';

const config = {
  apiKey: "AIzaSyDXC_fUPrcZ5f1W2AnBBA_XaCZvrVGYdJw",
  authDomain: "admin.piti.app", // "df-kirin.firebaseapp.com",
  databaseURL: "https://df-kirin.firebaseio.com",
  projectId: "df-kirin",
  storageBucket: "df-kirin.appspot.com",
  messagingSenderId: "816384609076"
};

firebase.initializeApp(config);

const serverTimestamp = () => {
  const ts = firebase.firestore.FieldValue.serverTimestamp();
  return ts;
}

export * from './redux';
export {
  serverTimestamp,
  createListenCollectionEpic,
  createListenDocEpic
}



// WEBPACK FOOTER //
// ./src/firebase/index.ts